// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.profile-info {
    padding: var(--space-and-half);
    display: flex;
    flex-direction: column;
    justify-content: center;
    /* box-shadow: var(--shadow-card-1); */
    /* border-radius: 10px; */
    border-radius: 10px 10px 0px 0px;
    background-color: var(--white-color);
    position: relative;
}
.profile-info__photo {
    padding: 0;
    margin: 0 auto;
    position: relative;
    display: flex;
    overflow: hidden;
    width: calc(calc(var(--space-x3) * 2) + var(--space-quarter));
    height: calc(calc(var(--space-x3) * 2) + var(--space-quarter));
    justify-content: center;
    align-items: center;
}
/* .width-photo{ 
    width: 19%;
} */
.profile-info__photo .icon-ball{
    font-size: calc(var(--space-x3) + var(--space-x2));
    font-weight: var(--font-bold);
    border-radius: 50%;
    padding: 5px;
    color: var(--white-color);
}
/* .profile-info__photo.no-photo {
    padding: var(--space);
} */
.profile-info__photo img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
}
.profile-info__photo__new-button {
    position: absolute;
    width: var(--space-and-half);
    height: var(--space-and-half);
    /* bottom: var(--space-half); */
    right: var(--space-half);
    top: 75%;
    right: 5%;
    /* background-color: var(--secondary-color); */
    /* border-radius: 50%; */
}
.profile-info__photo__new-button:hover {
    cursor: pointer;
    /* background-color: var(--hover-pb-bg-color); */
}
.profile-info__photo__edit-button{
    position: absolute;
    right: var(--space);
    top: var(--space);
    cursor: pointer;
}
.profile-info__fullname {
    margin-top: var(--space);
    text-align: center;
}

.profile-info__fullname .hubicon-award_star{
    font-size: var(--space);
    margin-left: var(--space-quarter);
}

.fullname_color{
    color: var(--primary-dark-color) !important;
}

.profile-info__username {
    margin-top: var(--space);
    text-align: center;
}

.username_color{
    color: var(--basic-gray-color) !important;
}

.profile-info__description {
    margin-top: var(--space-and-half);
    display: flex;
    justify-content: center;
    text-align: center;
    width: 100%;
}
.profile-info__description.baloa-table{
    color: var(--basic-gray-color);
}

.profile-info__description.baloa-table.link{
    cursor: pointer;
}

.profile-info__description.baloa-hyperlink{
    color: var(--new-green-color);
    justify-content: left;
    padding-left: var(--space-x2);
    cursor: pointer;
}
.profile-info__separator {
    margin-top: var(--space-and-half);
}
.profile-info__content{
    display: flex;
    justify-content: center;
    margin-top: var(--space-and-half);
}
.profile-info__content-buttons{
    display: flex;
    justify-content: center;
    margin-top: var(--space-and-half);
    gap: var(--space-and-half);
}
/* .profile-info__content__follows {
    margin-top: var(--space);
    display: flex;
    justify-content: center;
    cursor: pointer;
} */
.profile-info__content__follows__text {
    cursor: pointer;
}
.profile-info__content__follows__text:nth-child(2) {
    margin: 0 var(--space-x2);
}
.count-text{
    text-align: center;
}
.follows-text{
    color:var(--gray-color) !important; 
}
.profile-info__content__follows__following {
    width: 50%;
}
.profile-info__content__follows__followers {
    width: 50%;
}
.profile-info__action {
    position: absolute;
    bottom: calc(var(--space-x2) * -1);
    left: 0;
    width: 100%;
    display: flex;
    justify-content: center;
}
.profile-info__action__button {}

.link-color{
    color: var(--new-green-color) !important;
}
.social-networks{
    text-align: center;
    margin-top: var(--space-x2);
    cursor: pointer;
}

/* .profile-info__content__botton {
    margin-left: var(--space-x2);
} */

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */
    .profile-info__content__botton .rounded-button {
        font-size: var(--space);
        line-height: calc( var(--space) + 2px );
        padding: 8px 20px !important;
        white-space: nowrap;
    }    
}`, "",{"version":3,"sources":["webpack://./src/app/profiles/components/profile-information/ProfileInformationComponent.style.css"],"names":[],"mappings":";AACA;IACI,8BAA8B;IAC9B,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,sCAAsC;IACtC,yBAAyB;IACzB,gCAAgC;IAChC,oCAAoC;IACpC,kBAAkB;AACtB;AACA;IACI,UAAU;IACV,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,6DAA6D;IAC7D,8DAA8D;IAC9D,uBAAuB;IACvB,mBAAmB;AACvB;AACA;;GAEG;AACH;IACI,kDAAkD;IAClD,6BAA6B;IAC7B,kBAAkB;IAClB,YAAY;IACZ,yBAAyB;AAC7B;AACA;;GAEG;AACH;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,4BAA4B;IAC5B,6BAA6B;IAC7B,+BAA+B;IAC/B,wBAAwB;IACxB,QAAQ;IACR,SAAS;IACT,8CAA8C;IAC9C,wBAAwB;AAC5B;AACA;IACI,eAAe;IACf,gDAAgD;AACpD;AACA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,wBAAwB;IACxB,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,iCAAiC;AACrC;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,wBAAwB;IACxB,kBAAkB;AACtB;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,iCAAiC;IACjC,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,WAAW;AACf;AACA;IACI,8BAA8B;AAClC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,6BAA6B;IAC7B,qBAAqB;IACrB,6BAA6B;IAC7B,eAAe;AACnB;AACA;IACI,iCAAiC;AACrC;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,iCAAiC;AACrC;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,iCAAiC;IACjC,0BAA0B;AAC9B;AACA;;;;;GAKG;AACH;IACI,eAAe;AACnB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kCAAkC;AACtC;AACA;IACI,UAAU;AACd;AACA;IACI,UAAU;AACd;AACA;IACI,kBAAkB;IAClB,kCAAkC;IAClC,OAAO;IACP,WAAW;IACX,aAAa;IACb,uBAAuB;AAC3B;AACA,+BAA+B;;AAE/B;IACI,wCAAwC;AAC5C;AACA;IACI,kBAAkB;IAClB,2BAA2B;IAC3B,eAAe;AACnB;;AAEA;;GAEG;;AAEH,yCAAyC,4BAA4B;IACjE;QACI,uBAAuB;QACvB,uCAAuC;QACvC,4BAA4B;QAC5B,mBAAmB;IACvB;AACJ","sourcesContent":["\n.profile-info {\n    padding: var(--space-and-half);\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    /* box-shadow: var(--shadow-card-1); */\n    /* border-radius: 10px; */\n    border-radius: 10px 10px 0px 0px;\n    background-color: var(--white-color);\n    position: relative;\n}\n.profile-info__photo {\n    padding: 0;\n    margin: 0 auto;\n    position: relative;\n    display: flex;\n    overflow: hidden;\n    width: calc(calc(var(--space-x3) * 2) + var(--space-quarter));\n    height: calc(calc(var(--space-x3) * 2) + var(--space-quarter));\n    justify-content: center;\n    align-items: center;\n}\n/* .width-photo{ \n    width: 19%;\n} */\n.profile-info__photo .icon-ball{\n    font-size: calc(var(--space-x3) + var(--space-x2));\n    font-weight: var(--font-bold);\n    border-radius: 50%;\n    padding: 5px;\n    color: var(--white-color);\n}\n/* .profile-info__photo.no-photo {\n    padding: var(--space);\n} */\n.profile-info__photo img {\n    width: 100%;\n    height: 100%;\n    border-radius: 50%;\n}\n.profile-info__photo__new-button {\n    position: absolute;\n    width: var(--space-and-half);\n    height: var(--space-and-half);\n    /* bottom: var(--space-half); */\n    right: var(--space-half);\n    top: 75%;\n    right: 5%;\n    /* background-color: var(--secondary-color); */\n    /* border-radius: 50%; */\n}\n.profile-info__photo__new-button:hover {\n    cursor: pointer;\n    /* background-color: var(--hover-pb-bg-color); */\n}\n.profile-info__photo__edit-button{\n    position: absolute;\n    right: var(--space);\n    top: var(--space);\n    cursor: pointer;\n}\n.profile-info__fullname {\n    margin-top: var(--space);\n    text-align: center;\n}\n\n.profile-info__fullname .hubicon-award_star{\n    font-size: var(--space);\n    margin-left: var(--space-quarter);\n}\n\n.fullname_color{\n    color: var(--primary-dark-color) !important;\n}\n\n.profile-info__username {\n    margin-top: var(--space);\n    text-align: center;\n}\n\n.username_color{\n    color: var(--basic-gray-color) !important;\n}\n\n.profile-info__description {\n    margin-top: var(--space-and-half);\n    display: flex;\n    justify-content: center;\n    text-align: center;\n    width: 100%;\n}\n.profile-info__description.baloa-table{\n    color: var(--basic-gray-color);\n}\n\n.profile-info__description.baloa-table.link{\n    cursor: pointer;\n}\n\n.profile-info__description.baloa-hyperlink{\n    color: var(--new-green-color);\n    justify-content: left;\n    padding-left: var(--space-x2);\n    cursor: pointer;\n}\n.profile-info__separator {\n    margin-top: var(--space-and-half);\n}\n.profile-info__content{\n    display: flex;\n    justify-content: center;\n    margin-top: var(--space-and-half);\n}\n.profile-info__content-buttons{\n    display: flex;\n    justify-content: center;\n    margin-top: var(--space-and-half);\n    gap: var(--space-and-half);\n}\n/* .profile-info__content__follows {\n    margin-top: var(--space);\n    display: flex;\n    justify-content: center;\n    cursor: pointer;\n} */\n.profile-info__content__follows__text {\n    cursor: pointer;\n}\n.profile-info__content__follows__text:nth-child(2) {\n    margin: 0 var(--space-x2);\n}\n.count-text{\n    text-align: center;\n}\n.follows-text{\n    color:var(--gray-color) !important; \n}\n.profile-info__content__follows__following {\n    width: 50%;\n}\n.profile-info__content__follows__followers {\n    width: 50%;\n}\n.profile-info__action {\n    position: absolute;\n    bottom: calc(var(--space-x2) * -1);\n    left: 0;\n    width: 100%;\n    display: flex;\n    justify-content: center;\n}\n.profile-info__action__button {}\n\n.link-color{\n    color: var(--new-green-color) !important;\n}\n.social-networks{\n    text-align: center;\n    margin-top: var(--space-x2);\n    cursor: pointer;\n}\n\n/* .profile-info__content__botton {\n    margin-left: var(--space-x2);\n} */\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n    .profile-info__content__botton .rounded-button {\n        font-size: var(--space);\n        line-height: calc( var(--space) + 2px );\n        padding: 8px 20px !important;\n        white-space: nowrap;\n    }    \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
